import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
                热门排行
              </h2>
              <p className="text-sm text-foreground-600">实时热度榜单，发现当下最火的韩国漫画</p>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium cursor-pointer whitespace-nowrap">热度榜</span>
              <span className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium cursor-pointer whitespace-nowrap hover:bg-background-200 transition-colors">新作榜</span>
              <span className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs font-medium cursor-pointer whitespace-nowrap hover:bg-background-200 transition-colors">完结榜</span>
            </div>
          </div>

          <div className="space-y-2.5">
            {rankingItems.map((item) => (
              <a
                key={item.rank}
                href="#cards"
                className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50/50 border border-transparent hover:border-primary-100 transition-all duration-200 no-underline cursor-pointer group"
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h3>
                    {item.change === 'up' && (
                      <i className="ri-arrow-up-line text-xs text-accent-500 flex-shrink-0"></i>
                    )}
                    {item.change === 'down' && (
                      <i className="ri-arrow-down-line text-xs text-secondary-400 flex-shrink-0"></i>
                    )}
                    {item.change === 'same' && (
                      <span className="text-xs text-foreground-400 flex-shrink-0">—</span>
                    )}
                  </div>
                  <span className="text-xs text-foreground-500">{item.genre}</span>
                </div>
                <span className="text-sm font-semibold text-accent-600 whitespace-nowrap flex-shrink-0">{item.heat}</span>
              </a>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#cards"
              className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
            >
              查看完整榜单
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}